function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, String, inputValue) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const proxyAttrs = {};;
    ['closeable', 'open'].forEach(attr => proxyAttrs[attr] = $attr(attr));;
    return {
      value: (h("mp-modal", {
        "attrs": proxyAttrs,
        "on": {
          change: $helpers.modalChanged
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-confirm-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-confirm-body': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-confirm-body-content': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($attr(`title`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-confirm-title': true
                  },
                }, [__vjadeSafeCode($attr(`title`))]));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(($attr(`description`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-confirm-description': true
                  },
                }, [__vjadeSafeCode($attr(`description`))]));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(($attr(`show-input`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("input", {
                  "hook": {
                    insert: $helpers.onInputInserted
                  },
                  "attrs": {
                    'type': `text`,
                  },
                  "on": {
                    input: $helpers.changeInputValue,
                    keyup: $helpers.commitInputValue,
                    change: ev => ev.stopPropagation(),
                  },
                  "props": {
                    value: inputValue
                  },
                  "class": {
                    'mp-confirm-input': true
                  },
                }));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("slot"));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-confirm-buttons': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((!$attr(`hide-cancel-button`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($attr(`theme`) !== `info`) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": {
                    size: `small`,
                    theme: `tertiary`
                  },
                  "on": {
                    click: $helpers.cancel
                  },
                  "class": {
                    'mp-confirm-button-cancel': true,
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat($attr(`cancel-button-label`) || `Cancel`);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": {
                disabled: $helpers.isConfirmButtonDisabled(),
                size: `small`,
                theme: `primary`,
                destructive: $attr(`theme`) === `delete`,
              },
              "on": {
                click: $helpers.confirm
              },
              "class": {
                'mp-confirm-button-accept': true,
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($attr(`confirm-button-label`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat($attr(`confirm-button-label`));;
                return __jade_nodes
              }).call(this)) : ($attr(`theme`) === `delete`) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Delete");;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Ok");;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "inputValue" in locals ? locals.inputValue : typeof inputValue !== "undefined" ? inputValue : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;